import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class FeeService {

    constructor(private http: CustomHttpService) { }

    getAllFeeGroupWithCount(params: any): Observable<any> {
        return this.http.post(environment.getAllFeeGroupWithCount, params);
    }

    createFeeGroup(data: any): Observable<any> {
        return this.http.post(environment.createFeeGroup, data);
    }

    updateFeeGroup(data: any): Observable<any> {
        return this.http.post(environment.updateFeeGroup, data);
    }

    deleteFeeGroup(data: any): Observable<any> {
        return this.http.post(environment.deleteFeeGroup, data);
    }


    getAllFeeStructures(params: any): Observable<any> {
        return this.http.post(environment.getAllFeeStructures, params);
    }

    createFeeStructure(data: any): Observable<any> {
        return this.http.post(environment.createFeeStructure, data);
    }

    updateFeeStructure(data: any): Observable<any> {
        return this.http.post(environment.updateFeeStructure, data);
    }

    deleteFeeStructure(data: any): Observable<any> {
        return this.http.post(environment.deleteFeeStructure, data);
    }

    getAllActiveFeeGroups(data: any): Observable<any> {
        return this.http.post(environment.getAllActiveFeeGroups, data);
    }

}

